<template>
  <component
    :is="props.progressBarData.progressbarHeadline ? 'header' : 'aside'"
    v-editable="props.progressBarData"
    class="header-progressBar"
  >
    <ol>
      <li
        v-for="(n, index) in Number(props.progressBarData.maxProgressbarStep)"
        :key="index"
        :class="{
          done: n < props.progressBarData.currentProgressbarStep,
          active: n == props.progressBarData.currentProgressbarStep,
          upcomming: n > props.progressBarData.currentProgressbarStep
        }"
      >
        <span v-if="n < props.progressBarData.currentProgressbarStep">
          <PflegeIcon name="icon-success" />
        </span>
        <span v-else>{{ n }}</span>
      </li>
    </ol>
    <h2 v-if="props.progressBarData.progressbarHeadline" class="h5 text-neutral-80">
      {{ props.progressBarData.progressbarHeadline }}
    </h2>
  </component>
</template>

<script setup>
const props = defineProps({
  progressBarData: {
    type: Object,
    required: true,
    default: () => ({
      progressbarHeadline: '',
      currentProgressbarStep: 1,
      maxProgressbarStep: 3
    }),
    validator: (value) => {
      return (
        typeof value.progressbarHeadline === 'string' &&
        value.currentProgressbarStep >= 1 &&
        value.currentProgressbarStep <= 9 &&
        value.maxProgressbarStep >= 3 &&
        value.maxProgressbarStep <= 9
      )
    }
  }
})
</script>

<style scoped>
.header-progressBar {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-block-end: 2rem;
}

.header-progressBar ol {
  list-style: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  padding-block: 0.75rem;
  padding-inline: 0;
}

.header-progressBar ol li {
  flex: 1 1 auto;
  text-align: center;
  display: flex;
  align-items: center;
  margin: 0;
}

.header-progressBar ol li:first-child,
.header-progressBar ol li:last-child {
  flex: 0.5 1 auto;
  content: '';
}

.header-progressBar ol li:first-child::before,
.header-progressBar ol li:last-child::after {
  flex: none;
}

.header-progressBar ol li:not(:first-child)::before,
.header-progressBar ol li:not(:last-child)::after {
  content: '';
  border-bottom: 2px solid var(--blue-lightest);
  flex: 1 1 auto;
}

.header-progressBar ol li.active:not(:first-child)::before,
.header-progressBar ol li.done:not(:first-child)::before,
.header-progressBar ol li.done:not(:last-child)::after {
  border-color: var(--blue-light);
}

.header-progressBar ol li span {
  display: inline-block;
  width: 1.5rem;
  height: 1.5rem;
  line-height: 1.5rem;
  border-radius: 50%;
  font-size: 1rem;
  color: var(--white);
}

.header-progressBar ol li span svg {
  margin: 0.25rem 0;
}

.header-progressBar ol li.upcomming span {
  background-color: var(--blue-lightest);
  color: var(--neutral-80);
}

.header-progressBar ol li.done span {
  background-color: var(--blue-light);
  color: var(--white);
}

.header-progressBar ol li.active span {
  background-color: var(--coral-dark);
  width: 2rem;
  height: 2rem;
  line-height: 2rem;
}
</style>
